import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthForm } from '../types/auth';

type CognitoUser = {
  email: string;
  isAuthorized: boolean;
  password: string;
  metadata: {
    picture: string;
    name: string;
    emailVerified: boolean;
    isUsedSocialProviders: boolean;
  };
};

type InitialState = {
  type: AuthForm;
  cognitoUser: CognitoUser;
};

const initialState: InitialState = {
  type: AuthForm.Signup,
  cognitoUser: {
    email: '',
    isAuthorized: false,
    password: '',
    metadata: {
      picture: '',
      name: '',
      emailVerified: false,
      isUsedSocialProviders: false,
    },
  },
};

const cognitoSlice = createSlice({
  name: 'cognito',
  initialState,
  reducers: {
    setAuthForm: (state, { payload }: PayloadAction<AuthForm>) => {
      state.type = payload;
      return state;
    },

    setCognitoUserEmail: (state, { payload }: PayloadAction<CognitoUser['email']>) => {
      state.cognitoUser.email = payload;
    },

    setCognitoUserPassword: (state, { payload }: PayloadAction<CognitoUser['password']>) => {
      state.cognitoUser.password = payload;
    },

    setCognitoUserAuthorized: (state) => {
      state.cognitoUser.isAuthorized = true;
    },

    setCognitoUserMetadata: (state, { payload }: PayloadAction<CognitoUser['metadata']>) => {
      state.cognitoUser.metadata = {
        ...state.cognitoUser.metadata,
        ...payload,
      };
    },
  },
});

export default cognitoSlice.reducer;

export const {
  setAuthForm,
  setCognitoUserEmail,
  setCognitoUserAuthorized,
  setCognitoUserPassword,
  setCognitoUserMetadata,
} = cognitoSlice.actions;
